import React, { useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { checkAuthState } from "../core/redux/authActions";
import { all_routes } from "./all_routes";
import PropTypes from "prop-types";

/**
 * ProtectedRoute component that redirects to login if not authenticated
 * and restricts access based on user role
 */
const ProtectedRoute = ({ allowedRoles, children }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { isAuthenticated, userRole } = useSelector((state) => state.auth);

  useEffect(() => {
    // Check if user is authenticated when component mounts
    dispatch(checkAuthState());
  }, [dispatch]);

  // If not authenticated, redirect to login
  if (!isAuthenticated) {
    return (
      <Navigate to={all_routes.signin} state={{ from: location }} replace />
    );
  }

  // If allowedRoles is provided and user's role is not in the allowed roles, redirect to dashboard
  if (allowedRoles && !allowedRoles.includes(userRole)) {
    return <Navigate to={all_routes.newdashboard} replace />;
  }

  // If authenticated and authorized, render the child routes
  return children || <Outlet />;
};

ProtectedRoute.propTypes = {
  allowedRoles: PropTypes.arrayOf(PropTypes.string),
  children: PropTypes.node,
};

export default ProtectedRoute;
